// Set notices

function setProtocolsLoadingNotice() {
  $('.protocol-list__wrapper').html('<div class="panel__empty">' + __('panelNoticeLoadingProtocols') + '</div>');
}

function setProtocolsNoneFoundNotice() {
  $('.protocol-list__wrapper').html('<div class="panel__empty">' + __('panelNoticeNoProtocols') + '</div>');
}

function setProtocolsLoadingError() {
  $('.protocol-list__wrapper').html('<div class="panel__empty">' + __('panelNoticeCouldNotLoadProtocols') + '</div>');
}

// Get protocols and construct list

function initProtocols() {
  // Get protocols
  $.ajax({
    url: settings.apiEndpoint + '/api/protocols',
    type: 'GET',
    headers: {
      apiToken: settings.apiToken,
      projectId: settings.protocolProjectId,
      nodeId: app.nodeId
    },
    beforeSend: function () {
      setProtocolsLoadingNotice();
    },
    success: function (response) {
      if (response && response.success) {
        const project = response.project;
        if (project && project.protocols && project.protocols.length) {
          $('.protocol-list__wrapper').html('');
          for (let i = 0; i < project.protocols.length; i++) {
            const protocol = project.protocols[i];
            addProtocolButtonToList(protocol);
          }
          return;
        }
        setProtocolsNoneFoundNotice();
        return;
      }
      setProtocolsLoadingError();
    },
    error: function () {
      setProtocolsLoadingError();
    }
  });
}

// Add a protocol button to the list

function addProtocolButtonToList(protocol) {
  const wrapper = $('<div class="protocol-list__protocol-wrapper"/>').attr('data-id', protocol.id);

  const header = $('<div class="protocol-list__protocol-header"/>').appendTo(wrapper);

  // Title
  header.append($('<div class="protocol-list__protocol-title"/>').html(protocol.title));

  // Add button
  header.append(
    $('<div class="protocol-list__add-inspection-button icon-add"/>').on('click', function () {
      openInspectionModal(protocol);
    })
  );

  var inspectionsWrapper = $('<div class="protocol-list__ispections-wrapper"/>').appendTo(wrapper);

  if (protocol.inspections && protocol.inspections.length) {
    $.each(protocol.inspections, function (index, item) {
      inspectionsWrapper.append(getInspectionButtonElement(protocol, item));
    });
  } else {
    inspectionsWrapper.append(
      $('<div class="inspection-button__wrapper no-inspections"/>').html(__('panelNoticeNoInspections'))
    );
  }

  // Append to list
  $('.protocol-list__wrapper').append(wrapper);
}

function getInspectionButtonElement(protocol, inspection) {
  var inspectionCreatedDate = getIssueCreatedDate(inspection.date_of_inspection);

  return $('<div class="inspection-button__wrapper-outer"/>')
    .attr('data-id', inspection.id)
    .append(
      $('<div class="inspection-button__wrapper"/>')
        .attr('data-id', inspection.id)
        .append($('<div class="inspection-button__title"/>').html(inspection.object))
        .append($('<div class="inspection-button__date"/>').html(inspectionCreatedDate))

        .on('click', function () {
          openInspectionModal(protocol, inspection);
        })
    )
    .append(
      $('<a target="_blank" class="inspection-button__pdf-link icon-pdf"/>').attr(
        'href',
        settings.apiEndpoint + '/inspection/pdf/' + inspection.id
      )
    )
    .append(
      $('<div class="inspection-button__push-pins icon-location-on"/>').on('click', function () {
        toggleInspectionItemPushPins(inspection.id);
      })
    );
}

// Protocol modal

$(function () {
  if (isFeatureEnabled('protocolPanel')) {
    app.showProtocolModal = new jBox('Modal', {
      id: 'protocol-modal',
      addClass: 'modal-bim360 modal-bim360--title-left',
      width: 520,
      height: '100%',
      title: '&nbsp',
      closeButton: 'title',
      isolateScroll: false,
      adjustDistance: 16,
      createOnInit: true,
      zIndex: 10000,
      onCreated: function () {
        updateModalCloseIcon(this.wrapper);
      },
      onClose: function () {
        app.protocolItemModal && app.protocolItemModal.close();
      }
    });
  }
});

// Protocol modal

function setProtocolModalLoadingNotice() {
  if (!app.showProtocolModal) {
    return;
  }
  app.showProtocolModal.content.html('<div class="panel__empty">' + __('inspectionNoticeLoadingInspection') + '</div>');
}

function setProtocolModalLoadingError() {
  app.showProtocolModal.content.html(
    '<div class="panel__empty">' + __('inspectionNoticeCouldNotLoadInspection') + '</div>'
  );
}

function openInspectionModal(protocol, inspection) {
  if (!isFeatureEnabled('protocolPanel') || !app.showProtocolModal) {
    return;
  }

  app.showProtocolModal.setTitle(protocol.title);

  if (!inspection) {
    var content = getProtocolModalContent(protocol);
    app.showProtocolModal.content.html(content);
    app.showProtocolModal.open();
    activateProtocolModalSection('inspection');
    return;
  }

  $.ajax({
    url: settings.apiEndpoint + '/api/inspection/' + inspection.id,
    type: 'GET',
    headers: {
      apiToken: settings.apiToken
    },
    beforeSend: function () {
      setProtocolModalLoadingNotice();
      app.showProtocolModal.open();
    },
    success: function (response) {
      if (response && response.success && response.inspection) {
        app.selectedInspection = response.inspection;
        var content = getProtocolModalContent(protocol, response.inspection);
        app.showProtocolModal.content.html(content);
        activateProtocolModalSection('inspection');
        return;
      }
      app.selectedInspection = null;
      setProtocolModalLoadingError();
    },
    error: function () {
      app.selectedInspection = null;
      error();
      setProtocolModalLoadingError();
    }
  });
}

// The protocol modal content

function getProtocolModalContent(protocol, inspection) {
  var wrapper = $('<div class="protocol-modal__wrapper"/>');

  var protocolNavWrapper = $('<div class="protocol-modal__nav-wrapper"/>').appendTo(wrapper);

  $('<div class="protocol-modal__nav-button protocol-modal__nav-button--inspection"/>')
    .html(__('protocolModalNavButtonInspection'))
    .appendTo(protocolNavWrapper)
    .on('click', function () {
      activateProtocolModalSection('inspection');
    });

  $('<div class="protocol-modal__nav-button protocol-modal__nav-button--issues"/>')
    .html(__('protocolModalNavButtonIssues'))
    .appendTo(protocolNavWrapper)
    .on('click', function () {
      activateProtocolModalSection('issues');
    });

  var protocolSectionInspection = $(
    '<div class="protocol-modal__section protocol-modal__section--inspection"/>'
  ).appendTo(wrapper);

  var formWrapper = $('<div class="protocol-modal__form-wrapper"/>').appendTo(protocolSectionInspection);

  formWrapper.append(
    $('<input type="hidden" id="edit-protocol__id">').val(inspection && inspection.id ? inspection.id : '')
  );

  if (protocol.type == "AcceptanceReport") {
    var values = [
      [
        {
          id: 'object',
          title: __('inspectionMainValueTypeAcceptanceReportConstructionWork')
        }
      ],
      [
        {
          id: 'custom_value1',
          title: __('inspectionMainValueTypeAcceptanceReportStructure')
        }
      ],
      [
        {
          id: 'custom_value2',
          title: __('inspectionMainValueTypeAcceptanceReportStructureNumber')
        }
      ],
      [
        {
          id: 'date_of_inspection',
          title: __('inspectionMainValueDateOfInspection')
        },
      ],
      [
        {
          id: 'inspectors',
          title: __('inspectionMainValueInspector')
        }
      ],
      [
        {
          id: 'description',
          title: __('inspectionMainValueDescription')
        }
      ]
    ];
  } else {
    var values = [
      [
        {
          id: 'object',
          title: __('inspectionMainValueObject')
        }
      ],
      [
        {
          id: 'documents',
          title: __('inspectionMainValueDocuments')
        }
      ],
      [
        {
          id: 'date_of_inspection',
          title: __('inspectionMainValueDateOfInspection')
        },
        {
          id: 'time_of_inspection',
          title: __('inspectionMainValueTimeOfInspection')
        }
      ],
      [
        {
          id: 'weather',
          title: __('inspectionMainValueWeather')
        },
        {
          id: 'temperature',
          title: __('inspectionMainValueTemperature')
        }
      ],
      [
        {
          id: 'inspectors',
          title: __('inspectionMainValueInspector')
        }
      ],
      [
        {
          id: 'description',
          title: __('inspectionMainValueDescription')
        }
      ]
    ];
  }

  $.each(
    values,
    function (index, row) {
      var rowWrapper = $('<div class="protocol-modal__input-row"/>')
        .attr('data-items', row.length)
        .appendTo(formWrapper);

      $.each(row, function (index2, item) {
        if (item.id === 'inspectors') {
          rowWrapper.append($('<div class="protocol-modal__input-label"/>').html(item.title));
          rowWrapper.addClass('protocol-modal__input-row--inspectors');
          rowWrapper.attr('data-items', 1);

          if (inspection && inspection[item.id]) {
            var inspectors = JSON.parse(inspection[item.id]);

            $.each(inspectors, function (index, item) {
              var inputWrapper = $('<div class="protocol-modal__input-wrapper"/>');
              addInvolvedPersonRow(inputWrapper, item.label, item.name, item.signature);
              inputWrapper.appendTo(rowWrapper);
            });
          } else {
            var inputWrapper = $('<div class="protocol-modal__input-wrapper"/>');
            addInvolvedPersonRow(inputWrapper);
            inputWrapper.appendTo(rowWrapper);
          }

          rowWrapper.append(
            $('<div class="edit-protocol__add-inspector-button"/>')
              .html('<i class="icon-add"></i><span>' + __('inspectionAddMoreInspectorsButton') + '</span>')
              .on('click', function () {
                var inputRow = $('.protocol-modal__input-row--inspectors');
                var inputWrapper = $('<div class="protocol-modal__input-wrapper"/>');
                addInvolvedPersonRow(inputWrapper);
                inputWrapper.appendTo(inputRow);
                $(this).appendTo(inputRow);
              })
          );
        } else {
          var inputWrapper = $('<div class="protocol-modal__input-wrapper"/>');
          inputWrapper.append($('<div class="protocol-modal__input-label"/>').html(item.title));

          if (item.id === 'date_of_inspection') {
            var dateObj = new Date();
            var dateVal =
              dateObj.getFullYear() +
              '-' +
              ('0' + (dateObj.getMonth() + 1)).slice(-2) +
              '-' +
              ('0' + dateObj.getDate()).slice(-2);

            inputWrapper.append(
              $('<input type="date" class="textfield" id="edit-protocol__' + item.id + '"/>').val(
                inspection ? inspection[item.id] : dateVal
              )
            );
          } else if (item.id === 'time_of_inspection') {
            var dateObj = new Date();
            var timeVal = ('0' + dateObj.getHours()).slice(-2) + ':' + ('0' + dateObj.getMinutes()).slice(-2);

            inputWrapper.append(
              $('<input type="time" class="textfield" id="edit-protocol__' + item.id + '"/>').val(
                inspection ? inspection[item.id] : timeVal
              )
            );
          } else if (item.id === 'description') {
            inputWrapper.append(
              $('<textarea class="textfield" id="edit-protocol__' + item.id + '" rows="3"/>').val(
                inspection ? inspection[item.id] : timeVal
              )
            );
          } else {
            inputWrapper.append(
              $('<input type="text" class="textfield" id="edit-protocol__' + item.id + '" spellcheck="false"/>').val(
                inspection && inspection[item.id] ? inspection[item.id] : ''
              )
            );
          }

          inputWrapper.appendTo(rowWrapper);
        }
      });
    }
  );

  var inspectionFooter = $('<div class="protocol-modal__footer"/>').appendTo(protocolSectionInspection);

  inspectionFooter.append(
    $('<button id="edit-protocol__save-button" class="button">' + __('saveButton') + '</button>').on(
      'click',
      function () {
        saveInspection(protocol);
      }
    )
  );

  var protocolSectionIssues = $('<div class="protocol-modal__section protocol-modal__section--issues"/>').appendTo(
    wrapper
  );

  var issuesWrapper = $('<div class="protocol-modal__items-wrapper"/>');
  protocolSectionIssues.append(issuesWrapper);
  issuesWrapper.append(getCategoriesWithIssueButtons(inspection));

  var footer = $('<div class="protocol-modal__footer"/>');

  var openInspectionModalButton = $(
    '<button id="add-protocol-item-button"' +
      (!inspection ? ' disabled="disabled"' : '') +
      ' class="button">' +
      __('issueAddIssue') +
      '</button>'
  );

  if (inspection) {
    openInspectionModalButton.on('click', function () {
      openInspectionItemModal(inspection);
    });
  }

  footer.append(openInspectionModalButton);

  protocolSectionIssues.append(footer);

  return wrapper;
}

// Add another row of involved person

function addInvolvedPersonRow(container, label, name, signature) {
  container.append(
    $(
      '<input type="text" class="textfield" name="edit-protocol__inspectors_label[]" placeholder="' +
        __('inspectionMainValueInspectorPlaceholderLabel') +
        '"/>'
    ).val(label || '')
  );

  container.append(
    $(
      '<input type="text" class="textfield" name="edit-protocol__inspectors_name[]" placeholder="' +
        __('inspectionMainValueInspectorPlaceholderName') +
        '"/>'
    ).val(name || '')
  );

  container.append($('<input type="hidden" name="edit-protocol__inspectors_signature[]"/>').val(signature || ''));

  container.append(
    $(
      '<div class="edit-protocol__inspectors_signature-button textfield-button icon-edit" onclick="openSignaturePad(this)">'
    )
      .val(signature || '')
      .addClass(signature ? 'has-signature' : '')
  );
}

// Show the content of a modal section

function activateProtocolModalSection(section) {
  $('.protocol-modal__section').removeClass('section-active');
  $('.protocol-modal__section--' + section).addClass('section-active');

  $('.protocol-modal__nav-button').removeClass('button-active');
  $('.protocol-modal__nav-button--' + section).addClass('button-active');
}

// Save protocol

function disableProtocolForm() {
  $('.protocol-modal__form-wrapper input, .protocol-modal__form-wrapper button, #edit-protocol__save-button').attr(
    'disabled',
    'disabled'
  );
}

function enableProtocolForm() {
  $(
    '.protocol-modal__form-wrapper input, .protocol-modal__form-wrapper button, #edit-protocol__save-button'
  ).removeAttr('disabled');
}

function setProtocolFormLoading() {
  $('#edit-protocol__save-button').addClass('loading-bar');
}

function removeProtocolFormLoading() {
  $('#edit-protocol__save-button').removeClass('loading-bar');
}

function saveInspection(protocol) {
  var id = $('#edit-protocol__id').val().trim();
  var object = $('#edit-protocol__object').length ? $('#edit-protocol__object').val().trim() : '';
  var documents = $('#edit-protocol__documents').length ? $('#edit-protocol__documents').val().trim() : '';
  var date_of_inspection = $('#edit-protocol__date_of_inspection').length ? $('#edit-protocol__date_of_inspection').val().trim() : '';
  var time_of_inspection = $('#edit-protocol__time_of_inspection').length ? $('#edit-protocol__time_of_inspection').val().trim() : '';
  var weather = $('#edit-protocol__weather').length ? $('#edit-protocol__weather').val().trim() : '';
  var temperature = $('#edit-protocol__temperature').length ? $('#edit-protocol__temperature').val().trim() : '';
  var description = $('#edit-protocol__description').length ? $('#edit-protocol__description').val().trim() : '';
  var custom_value1 = $('#edit-protocol__custom_value1').length ? $('#edit-protocol__custom_value1').val().trim() : '';
  var custom_value2 = $('#edit-protocol__custom_value2').length ? $('#edit-protocol__custom_value2').val().trim() : '';
  var custom_value3 = $('#edit-protocol__custom_value3').length ? $('#edit-protocol__custom_value3').val().trim() : '';

  var inspectors = [];

  var inspector_labels = $("input[name='edit-protocol__inspectors_label[]']");
  var inspector_names = $("input[name='edit-protocol__inspectors_name[]']");
  var inspector_signatures = $("input[name='edit-protocol__inspectors_signature[]']");

  $.each(inspector_labels, function (index, item) {
    inspectors.push({
      label: $(inspector_labels[index]).val().trim(),
      name: $(inspector_names[index]).val().trim(),
      signature: $(inspector_signatures[index]).val().trim()
    });
  });

  // TODO these errors are not validated in backend
  if (!object || !date_of_inspection) {
    if (!object) {
      addTextfieldError('#edit-protocol__object');
    }

    if (!date_of_inspection) {
      addTextfieldError('#edit-protocol__date_of_inspection');
    }

    animateEl($('#edit-protocol__save-button'), 'shake');
    return;
  }

  $.ajax({
    url: settings.apiEndpoint + '/api/inspection',
    type: 'POST',
    headers: {
      apiToken: settings.apiToken
    },
    data: {
      id: id || null,
      protocol_id: protocol.id,
      object: object,
      documents: documents,
      inspectors: JSON.stringify(inspectors),
      date_of_inspection: date_of_inspection,
      time_of_inspection: time_of_inspection,
      description: description,
      custom_value1: custom_value1,
      custom_value2: custom_value2,
      custom_value3: custom_value3,
      weather: weather,
      temperature: temperature
    },
    beforeSend: function () {
      disableProtocolForm();
      setProtocolFormLoading();
    },
    success: function (response) {
      enableProtocolForm();
      removeProtocolFormLoading();
      if (response && response.success) {
        if (!id) {
          $('#edit-protocol__id').val(response.inspection.id);
          $('.protocol-list__protocol-wrapper[data-id="' + protocol.id + '"] .protocol-list__ispections-wrapper')
            .find('.no-inspections')
            .remove();
          $(
            '.protocol-list__protocol-wrapper[data-id="' + protocol.id + '"] .protocol-list__ispections-wrapper'
          ).append(getInspectionButtonElement(protocol, response.inspection));
        } else {
          $('.inspection-button__wrapper[data-id="' + response.inspection.id + '"] .inspection-button__title').html(
            response.inspection.object
          );

          var inspectionCreatedDate = getIssueCreatedDate(response.inspection.date_of_inspection);
          $('.inspection-button__wrapper[data-id="' + response.inspection.id + '"] .inspection-button__date').html(
            inspectionCreatedDate
          );
        }
        $('#add-protocol-item-button')
          .off('click')
          .on('click', function () {
            openInspectionItemModal(response.inspection);
          });
        $('#add-protocol-item-button').removeAttr('disabled');
        success(__('inspectionSaveSuccessNotice'));
        return;
      }
      animateEl($('#edit-protocol__save-button'), 'shake');
      error();
    },
    error: function () {
      error();
      enableProtocolForm();
      removeProtocolFormLoading();
    }
  });
}

// Add item to protocol

function openInspectionItemModal(inspection, issue) {
  if (!app.protocolItemModal) {
    app.protocolItemModal = new jBox('Modal', {
      id: 'protocol-item-modal',
      addClass: 'modal-bim360 modal-bim360--title-left',
      width: 520,
      height: '100%',
      title: '&nbsp;',
      closeButton: 'title',
      isolateScroll: false,
      adjustDistance: 16,
      createOnInit: true,
      zIndex: 10100,
      overlay: false,
      content: $('#protocol-item-modal-content'),
      onCreated: function () {
        updateModalCloseIcon(this.wrapper);
      },
      onOpen: function () {
        if (inspection.protocol.type == "AcceptanceReport") {
          $('#protocol-item-modal__title').attr('placeholder', __('issueInputTypeAcceptanceReportTitlePlaceholder'));
        } else {
          $('#protocol-item-modal__title').attr('placeholder', __('issueInputTitlePlaceholder'));
        }
        removeTextfieldError('#protocol-item-modal__title');
        removeSelectfieldError('.protocol-category-select__wrapper');
      },
      onClose: function () {
        initPushPinExtension(function () {
          pushPinExtension.removeAllItems();
        });
      }
    });
  }

  // Init values

  $('#protocol-item-modal__issue_id').val(issue ? issue.id : '');

  // console.log('INSPECTION', inspection);

  $('#protocol-item-modal__inspection_id').val(inspection.id);

  $('.protocol-item-modal__pushpin-icon')
    .removeClass('icon-location-on')
    .removeClass('icon-location-check')
    .addClass(issue && issue.push_pin_data ? 'icon-location-check' : 'icon-location-on');

  $('.protocol-item-modal__pushpin-text').html(
    issue && issue.push_pin_data ? __('pushPinNoticeChangePushPinLocation') : __('pushPinNoticeAddPushPin')
  );

  $('#protocol-item-modal__pushpin-button')[issue && issue.push_pin_data ? 'addClass' : 'removeClass'](
    'push-pin-added'
  );

  var selected_components =
    issue && issue.selected_components ? JSON.parse(issue.selected_components) : [];
  $('#protocol-item-modal__components-button').html(
    selected_components && selected_components.length ? __('changeComponentsButton').replace('{n}', selected_components.length) : __('selectComponentsButton')
  );
  $('#protocol-item-modal__components-button').data('selected_components', selected_components);

  if (issue && issue.push_pin_data) {
    showInspectionPushPins([issue]);
  }

  $('.protocol-item-modal__attachments')[issue ? 'addClass' : 'removeClass']('attachments-active');

  $('.protocol-item-modal__attachments-count').html(
    issue && issue.files && issue.files.length ? issue.files.length : 0
  );

  initEditAttachmentsTooltip('.protocol-item-modal__attachments');

  // Add files

  var editFilesContainer = $('.edit-issue__attachments-tooltip-content');

  if (!issue || !issue.files || !issue.files.length) {
    editFilesContainer.html(
      '<div class="show-issue-modal__attachments-content--empty">' + __('attachmentsNoticeNoAttachments') + '</div>'
    );
    //$('.show-issue-modal__attachments').addClass('show-issue-modal__attachments--empty').html(__('attachmentsNoticeNoAttachments'));
  } else {
    //updateIssueAttachmentAmount(response.files.length);
    editFilesContainer.html('');
    //$('.show-issue-modal__attachments').html('');
    for (var i = 0; i < issue.files.length; i++) {
      var file = issue.files[i];
      var isImage = ['png', 'jpg', 'jpeg'].indexOf(file.filename.split('.').pop()) > -1;

      // Add attachments to issue
      // TODO
      // filesContainer.append(
      //   $('<div class="show-issue-modal__attachment"/>').html(
      //     '<a href="' +
      //       settings.apiEndpoint +
      //       '/file/' +
      //       file.issue_id + // TODO
      //       '/' +
      //       file.filename +
      //       '" target="_blank" data-title="' +
      //       file.filename_original.replace('"', "'") +
      //       '" class="' +
      //       (isImage ? 'attachment-image' : '') +
      //       '"><div class="show-issue-modal__attachment-file' +
      //       (isImage ? ' show-issue-modal__attachment-file--image' : ' icon-file') +
      //       '" ' +
      //       (isImage
      //         ? ' style="background-image: url(' +
      //           settings.apiEndpoint +
      //           '/file/' +
      //           file.issue_id +
      //           '/' +
      //           file.filename +
      //           ')"'
      //         : '') +
      //       '></div><div class="show-issue-modal__attachment-name">' +
      //       file.filename_original +
      //       '</div></a>'
      //   )
      // );

      // Add attachments to edit tooltip
      editFilesContainer.append(
        $('<div class="edit-attachment__container" data-id="' + file.id + '"/>').html(
          '<div class="edit-attachment__file' +
            (isImage ? ' edit-attachment__file--image' : ' icon-file') +
            '" ' +
            (isImage
              ? ' style="background-image: url(' +
                settings.apiEndpoint +
                '/file/' +
                'issue-' +
                file.inspection_item_id +
                '/' +
                (file.filename_thumbnail ? file.filename_thumbnail : file.filename) +
                ')"'
              : '') +
            '></div><div class="edit-attachment__filename">' +
            file.filename_original +
            '</div><div class="edit-attachment__button button button--small" onclick="deleteAttachment(' +
            file.id +
            ')">' +
            __('deleteButton') +
            '</div>'
        )
      );
    }

    if (app.imageModal) {
      app.imageModal.detach().attach();
    }
  }

  // Add screenshot
  $('.edit-issue__screenshot-preview')
    .data('screenshot-image', null)
    .css({
      backgroundImage:
        issue && issue.screenshot_filename
          ? 'url(' + settings.apiEndpoint + '/file/issue-' + issue.id + '/' + issue.screenshot_filename + ')'
          : 'none'
    });

  // Add pushpin data
  $('#protocol-item-modal__pushpin-button').data(
    'pushpin-data',
    issue && issue.pushpin_attributes
      ? {
          attributes: {
            // target_urn: issue.attributes.target_urn,
            starting_version: issue.attributes.starting_version,
            sheet_metadata: issue.attributes.sheet_metadata,
            pushpin_attributes: issue.attributes.pushpin_attributes
          }
        }
      : null
  );

  // Set title values
  app.protocolItemModal.setTitle(issue ? __('issueEditIssue') : __('issueAddIssue'));
  $('#protocol-item-modal__title').val(issue ? issue.title : '');

  // Reset categories

  closeProtocolTypeSelectOptions();
  $('.protocol-category-select__options').html('');
  $('.protocol-category-select__selection').html(__('issueInputCategoryPlaceholder'));
  $('.protocol-category-select__wrapper').removeClass('type-selected');
  $('.protocol-category-select__option-button').removeClass('option-selected');

  var fillProtocolOptionsHelper = function (item) {
    closeProtocolTypeSelectOptions();
    $('.protocol-category-select__wrapper').addClass('type-selected').removeClass('error');
    $('.protocol-category-select__option-button').removeClass('option-selected');
    $('.protocol-category-select__option-button[data-id="' + item.id + '"]').addClass('option-selected');
    $('.protocol-category-select__selection').html(
      $('.protocol-category-select__option-button[data-id="' + item.id + '"]').html()
    );
    fillProtocolOptions(item.options);
  };

  inspection.protocol &&
    inspection.protocol.categories &&
    $.each(inspection.protocol.categories, function (index, item) {
      $('.protocol-category-select__options').append(
        $('<div class="protocol-category-select__option-button"/>')
          .attr('data-id', item.id)
          .html(item.title)
          .on('click', function () {
            fillProtocolOptionsHelper(item);
          })
      );
    });

  if (issue) {
    fillProtocolOptionsHelper({
      id: issue.protocol_category_id,
      options: issue.options ? JSON.parse(issue.options) : []
    });
  } else {
    resetProtocolOptions();
  }

  // Open modal
  app.protocolItemModal.open();
}

function toggleProtocolTypeSelectOptions() {
  $('.protocol-category-select__wrapper').toggleClass('options-expanded');
}

function closeProtocolTypeSelectOptions() {
  $('.protocol-category-select__wrapper').removeClass('options-expanded');
}

// Fill protocol options

function fillProtocolOptions(options) {
  $('.protocol-item-modal__options').html('');

  if (options && options.length) {
    $.each(options, function (index, option) {
      // console.log('option', option);

      var optionWrapper = $('<div class="protocol-item-modal__option-wrapper"/>')
        .append(
          $('<div class="protocol-item-modal__option-header"/>')
            .append($('<div class="protocol-item-modal__option-title"/>').html(option.title))
            .append($('<div class="protocol-item-modal__option-toggle-icon icon-down"/>'))
            .on('click', function () {
              var wrapper = $(this).parents('.protocol-item-modal__option-wrapper');
              if (wrapper.hasClass('option-active')) {
                wrapper.removeClass('option-active').find('.protocol-item-modal__option-content').slideUp();
                return;
              }
              $('.protocol-item-modal__option-wrapper.option-active')
                .removeClass('option-active')
                .find('.protocol-item-modal__option-content')
                .slideUp();
              wrapper.addClass('option-active').find('.protocol-item-modal__option-content').slideDown();
            })
        )
        .appendTo($('.protocol-item-modal__options'));

      var optionContent = $('<div class="protocol-item-modal__option-content"/>');

      optionContent.data('option', option);

      var type = option.id ? option.value.type : option.type;
      var optionValue = option.id ? '' : option.value;

      switch (type) {
        case 'select-one':
        case 'select-many':
          var values = option.id ? JSON.parse(option.value.values) : option.values;

          if (values) {
            $.each(values, function (index, value) {
              var checked = false;

              if (optionValue) {
                if (type === 'select-one' && optionValue == index.toString()) {
                  checked = true;
                }
                if (type === 'select-many' && optionValue.length && optionValue.indexOf(index.toString()) > -1) {
                  checked = true;
                }
              }
              optionContent.append(
                $('<div class="protocol-item-modal__value-container"/>')
                  .attr('data-value', index)
                  .addClass(
                    value.color
                      ? 'protocol-item-modal__value-container--color protocol-item-modal__value-container--' +
                          value.color
                      : ''
                  )
                  .addClass(checked ? 'value-active' : '')
                  .append(
                    $(
                      '<div class="protocol-item-modal__value-toggler' +
                        (checked ? ' icon-checkbox-checked' : ' icon-checkbox') +
                        '"/>'
                    )
                  )
                  .append($('<div class="protocol-item-modal__value-title"/>').html(value.value))
              );
            });
          }

          if (type === 'select-one') {
            optionContent.addClass('protocol-item-modal__option-content--select-one');

            optionContent.find('.protocol-item-modal__value-container').on('click', function () {
              if ($(this).hasClass('value-active')) {
                $(this)
                  .removeClass('value-active')
                  .find('.protocol-item-modal__value-toggler')
                  .removeClass('icon-checkbox-checked')
                  .addClass('icon-checkbox');
                return;
              }
              $(this)
                .parent()
                .find('.protocol-item-modal__value-container.value-active')
                .removeClass('value-active')
                .find('.protocol-item-modal__value-toggler')
                .removeClass('icon-checkbox-checked')
                .addClass('icon-checkbox');

              $(this)
                .addClass('value-active')
                .find('.protocol-item-modal__value-toggler')
                .removeClass('icon-checkbox')
                .addClass('icon-checkbox-checked');
            });
          }

          if (type === 'select-many') {
            optionContent.addClass('protocol-item-modal__option-content--select-many');

            optionContent.find('.protocol-item-modal__value-container').on('click', function () {
              $(this).toggleClass('value-active');

              $(this)
                .find('.protocol-item-modal__value-toggler')
                .removeClass('icon-checkbox')
                .removeClass('icon-checkbox-checked')
                .addClass('icon-checkbox' + ($(this).hasClass('value-active') ? '-checked' : ''));
            });
          }

          break;

        case 'text':
          optionContent
            .addClass('protocol-item-modal__option-content--text')
            .append($('<input class="textfield" type="text"/>').val(optionValue));
          break;

        case 'number':
          optionContent
            .addClass('protocol-item-modal__option-content--number')
            .append($('<input class="textfield" type="number"/>').val(optionValue));
          break;
      }

      optionWrapper.append(optionContent);
    });
  }
}

// Reset protocol options

function resetProtocolOptions() {
  $('.protocol-item-modal__options').html('<div class="panel__empty">' + __('issueNoticeSelectACategory') + '</div>');
}

// Add a signature

function openSignaturePad(buttonEl) {
  $('.signature-pad__wrapper').addClass('signature-pad-active');
  $('.signature-pad__save-button').data('signature-button', $(buttonEl));

  // Create pad if it doesn't exist
  if (!app.signaturePad) {
    var canvas = document.querySelector('.signature-pad__canvas');
    app.signaturePad = new SignaturePad(canvas, {
      penColor: 'rgb(0, 15, 85)'
    });
  }

  // Clear data
  clearSignaturePad();
}

function closeSignaturePad() {
  $('.signature-pad__wrapper').removeClass('signature-pad-active');
  clearSignaturePad();
}

function clearSignaturePad() {
  if (!app.signaturePad) {
    return;
  }

  app.signaturePad.clear();
}

function saveSignature() {
  if (!app.signaturePad) {
    return;
  }

  var signature = app.signaturePad.toDataURL();

  var button = $('.signature-pad__save-button').data('signature-button');

  var signatureInput = button
    .parents('.protocol-modal__input-wrapper')
    .find("input[name='edit-protocol__inspectors_signature[]']");
  signatureInput.val(signature);

  button.addClass('has-signature');

  closeSignaturePad();
}
